module.exports = __webpack_public_path__ + "static/media/管道电伴热1.0a5da367.jpg";